import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { chessMessageClientRequestResponse } from './chessMessageClientRequestResponse-sidecar'
import { EChessMessage } from './chessMessageIds'
import { chessWebsockets } from './chessWebsockets-sidecar'

export interface IChessMessageClientRequest {
  multiId?: number
  command: EChessClientRequest
}

export enum EChessClientRequest {
  SitWhite = 1,
  SitBlack = 2,
  Spectate = 3,
}

export const messageId = EChessMessage.ClientRequest

export function write(m: IMessageWriter, d: IChessMessageClientRequest) {
  messageWriter.write8(m, messageId)
  messageWriter.write16(m, d.multiId || 0)
  messageWriter.write8(m, d.command)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IChessMessageClientRequest = {
    multiId: messageWriter.read16(m),
    command: messageWriter.read8(m),
  }
  return d
}

export function test() {
  let ex: IChessMessageClientRequest = {
    multiId: 1234,
    command: EChessClientRequest.Spectate,
  }
  messageWriter.test('client-request', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  if (chessWebsockets.getIsHost()) {
    if (msg.command === EChessClientRequest.SitWhite) {
      chessMessageClientRequestResponse.sendMessageAndImmediatelyExecute({
        multiId: msg.multiId || 0,
        command: msg.command,
      })
    }
    if (msg.command === EChessClientRequest.SitBlack) {
      chessMessageClientRequestResponse.sendMessageAndImmediatelyExecute({
        multiId: msg.multiId || 0,
        command: msg.command,
      })
    }
    if (msg.command === EChessClientRequest.Spectate) {
      chessMessageClientRequestResponse.sendMessageAndImmediatelyExecute({
        multiId: msg.multiId || 0,
        command: msg.command,
      })
    }
  }
}

export function sendMessageRequest(msg: IChessMessageClientRequest) {
  msg.multiId = chessWebsockets.getMultiId()
  websockets._sendMessageRequest(write, msg)
}
